import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {OperationCard} from "../../model/OperationCard";
import {ResourcePlanningService} from "../../services/ResourcePlanningService";
import {
  SlotAssignmentPerPoolReport,
  SlotAssignReportRange,
  SlotPoolAsssignmentReport
} from "../../model/ReportingSlots";

/**
 * Generated class for the SlotsPlanningProgressReportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-slots-planning-progress-report',
  templateUrl: 'slots-planning-progress-report.html',
})
export class SlotsPlanningProgressReportPage {
  uiloading: boolean;

  /**
   * simple operation name to display on top of page
   */
  private uiOperationName: string;

  /**
   * operation card, with basic identity information
   */
  private uiOpCard: OperationCard;
  /**
   * loaded report from the KPI Api
   */
  private report: SlotAssignmentPerPoolReport;
  currentRangeName: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, private resourcePlanningService: ResourcePlanningService) {
    let operation: OperationCard = this.navParams.get('operationCard');
    this.uiOperationName = operation.name;
    this.uiOpCard = operation;
  }

  ionViewWillEnter() {
    this.uiloading = true;
  }

  ionViewDidLoad() {
    console.log({page: 'SlotsPlanningProgressReportPage.ionViewDidLoad'});

    this.resourcePlanningService.loadOperationSlotPlanningProgressReport(this.uiOpCard.id, this.uiOpCard.earliestPlannableDate, this.uiOpCard.latestPlannableDate, 'WEEKLY').then(a => {
      this.report = a;
      console.log(a);
      if (this.report.rangeReports != null && this.report.rangeReports.length > 0) {
        this.currentRangeName = this.report.rangeReports[0].rangeName;
        this.report.rangeReports[0].uiIsVisible = true;
      }

      this.uiloading = false;
    });

  }

  displayRange(rr: SlotAssignReportRange) {
    if (this.report != null) {
      this.report.rangeReports.forEach(r => {
        if (r.rangeName == rr.rangeName) {
          this.currentRangeName = rr.rangeName;
          r.uiIsVisible = true;
        } else {
          r.uiIsVisible = false;
        }
      });
    }
  }

  computeStyleClass(poolRep: SlotPoolAsssignmentReport) {
    const r = poolRep.numberOfPlannedSlots / poolRep.totalNumberOfSlots;
    if (r > 0.8)
      return "slot-planning-ok";
    else if (r > 0.5)
      return "slot-planning-average";
    else return "slot-planning-bad";
  }
}



// WEBPACK FOOTER //
// ./src/pages/slots-planning-progress-report/slots-planning-progress-report.ts